import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { MdBackspace } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaFacebook, FaTruckLoading } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { GiLion } from "react-icons/gi";
import { FaFacebookF } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import { FaXTwitter } from "react-icons/fa6";
import { Button } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import { useContext } from "react";
import { IoLocationSharp } from "react-icons/io5";
import { MdLocalPhone } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import Loading from "./Loading";
import { UsersContext } from "../context/UsersContext";
import useIsLargeScreen from "../utils/useIsLargeScreen";
import SideBar from "../components/menu/SideBar";
import BackBtn from "../components/menu/BackBtn";
import { VersionContext } from "../context/VersionContext";
import BackBtnLarge from "../components/menu/BackBtnLarge";

const Contacts = () => {
  const { version } = useContext(VersionContext);

  const isLargeScreen = useIsLargeScreen();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const { isAuthenticated } = useContext(AuthContext);
  const { sendEmail, loading } = useContext(UsersContext);
  useEffect(() => {
    version();
  }, []);
  const onSubmit = async (data) => {
    console.log(data.messageBody);

    const response = await sendEmail(data);

    if (response?.status === 200) {
      reset();
    }
  };
  return (
    <div className=''>
      {isLargeScreen && <SideBar />}
      <div className='section-page section-full-page section-orders section-large page-large-container yellow-background min-100'>
        <BackBtn />
        {isLargeScreen && <BackBtnLarge />}
        {loading && <Loading />}

        <div className='section-page'>
          <section className='blue-background pb-5'>
            <div className='section-center'>
              <h2 className='section-title pt-4'>I nostri contatti</h2>
              <div className='contacts-form-section '>
                <div className='contacts-main-container d-flex flex-column flex-lg-row align-items-center flex-lg-row-reverse pb-3'>
                  <article className='contact-info w-100 mb-4 mb-lg-0 ms-lg-3 ms-xl-4'>
                    <h4>Hai domande?</h4>
                    <p>
                      Per entrare in contatto con noi{" "}
                      <span className='cl-brown fw-bold'>compila il form</span>,
                      cosi facendo invierai una mail alla casella di posta di Ti
                      pianto per amore.
                    </p>
                    <p>
                      Saremo felici di metterci in contatto con te e ti
                      informiamo che normalmente intercorre una settimana di
                      tempo prima di ricevere una nostra risposta.
                    </p>
                    <p className='cl-brown fw-bold'>
                      Non esitare a contattarci!
                    </p>
                  </article>
                  <article className='contact-form w-100 me-lg-3 me-xl-4'>
                    <Form
                      className='contact-form-container'
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      {/* <h5 className='mb-3'>Scrivici una mail (non attivo)</h5> */}

                      {!isAuthenticated && (
                        <Form.Group
                          className='mb-3'
                          controlId='exampleForm.ControlTextarea1'
                        >
                          <Form.Control
                            type='email'
                            placeholder='Inserisci il tuo indirizzo mail'
                            disabled={loading}
                            className='contact-form-email'
                            {...register("email", {
                              required: "inserisci indirizzo mail",
                              pattern: {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              },
                            })}
                          />
                          {errors.email && (
                            <em className='text-danger small'>
                              {errors.email?.message}
                            </em>
                          )}
                        </Form.Group>
                      )}
                      <Form.Group
                        className='contact-form-input mb-3'
                        controlId='exampleForm.ControlTextarea1'
                      >
                        <Form.Control
                          className='contact-form-input'
                          placeholder='Come possiamo aiutarti?'
                          disabled={loading}
                          as='textarea'
                          {...register("messageBody", {
                            required: "il messaggio non può essere vuoto",
                            minLength: 2,
                            message: "test",
                          })}
                          rows={4}
                        />
                        {errors.messageBody && (
                          <em className='text-danger small'>
                            {errors.messageBody?.message}
                          </em>
                        )}
                      </Form.Group>
                      <div className='mt-3 pb-5 pb-lg-0'>
                        <Button
                          disabled={loading}
                          className='w-100 text-align-center'
                          variant='primary'
                          type='submit'
                        >
                          Invia mail
                        </Button>
                      </div>
                    </Form>
                  </article>
                </div>
              </div>
            </div>
          </section>
          <section className='py-5 white-background'>
            <div className='section-center'>
              <div className=''>
                <h4>Chiamaci, scrivici o vienici a trovare</h4>
              </div>
              <div className='d-flex justify-content-center d-xl-block'>
                <div className='d-flex flex-column flex-xl-row py-xl-5 justify-content-between'>
                  <article className='mt-5 mt-xl-0 me-xl-1 contacts-info-item contacts-location mb-3 d-flex align-items-center d-flex flex-column'>
                    <span className='contacts-location-icon pb-3'>
                      <IoLocationSharp />{" "}
                    </span>
                    <span> contrada gravinella, 60 Fasano</span>
                  </article>
                  <article className='me-xl-1 contacts-info-item  contacts-email mb-3 d-flex align-items-center d-flex flex-column'>
                    <span className='contacts-location-icon pb-3'>
                      <MdEmail />
                    </span>
                    <span> tipiantoperamore@gmail.com </span>
                  </article>
                  <article className='contacts-info-item  contacts-email mb-5 mb-lg-3 d-flex align-items-center d-flex flex-column'>
                    <span className='contacts-location-icon pb-3'>
                      <MdLocalPhone />
                    </span>
                    <span>+39 3485384563</span>
                  </article>
                </div>
              </div>
            </div>
          </section>
          <section className='contacts-social-section py-5'>
            <div className='section-center'>
              <h4>Seguici sui nostri canali</h4>

              <div className='mt-5 d-flex flex-column  justify-content-around align-items-center w-100'>
                <article className='contacts-social-icon mb-4'>
                  <a
                    target='_blank'
                    href='https://www.instagram.com/tipiantoperamore?igsh=MWY5cTFhZWJ2NXM2eQ=='
                  >
                    {" "}
                    <FaInstagram />
                  </a>
                </article>
                <article className='contacts-social-icon mb-4'>
                  <a
                    target='_blank'
                    href='https://www.facebook.com/ti.pianto.per.amore/'
                  >
                    {" "}
                    <FaFacebookF />
                  </a>
                </article>
                <article className='contacts-social-icon mb-4'>
                  <a target='_blank' href='  https://x.com/Amici_ErnestV'>
                    {" "}
                    <FaXTwitter />
                  </a>
                </article>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
